export default "__VITE_ASSET__Bh9HbEn6__"